import { t } from "i18next";

export type PERIOD = {
    text: string,
    value: number
}

export const PERIODS: PERIOD[] = [
    {
        text: 'period:day',
        value: 1
    },
    {
        text:'period:week',
        value: 7
    },
    {
        text: 'period:month',
        value: 30
    },
    {
        text: 'period:quarter',
        value: 90
    },
    {
        text: 'firstSection:total',
        value: 0
    },
] 